import React, { useEffect, useRef, useState } from 'react';
import { AGENTES, TAREAS } from '../data/catalogo';
import { escenaDeCatalogo } from '../data/escenas';
import DemoAgencia from './DemoAgencia';
import Button from '../ds/components/Button';
import { evento } from '../lib/medicion';

// El catálogo (An, 05/11): un agente por área con sus tareas. Es la demostración del producto («tiene que linkearse
// de todos lados… concentrate en convertir»): vive en la página de Agencia y en /catalogo. Tocar una tarea abre su
// ficha con el video y un solo pedido fuerte, «La quiero», que abre la postulación con la tarea escrita; al lado, la
// demo si la landing la tiene, o «Solicitar demo» (An, 05/11). Una ficha por vez, en un diálogo. `inicial`: la tarea
// que abre sola (el link /catalogo#cobranzas).
const CatalogoAgencia = ({ abrirChat, datos, inicial = null }) => {
  const [abierta, setAbierta] = useState(inicial && TAREAS[inicial] ? inicial : null);
  const [probando, setProbando] = useState(false);
  const dialogo = useRef(null);
  const tarea = abierta && TAREAS[abierta];
  const escena = abierta && escenaDeCatalogo(abierta);

  useEffect(() => {
    const d = dialogo.current;
    if (!d) return;
    if (abierta && !d.open) d.showModal?.();
    if (!abierta && d.open) d.close();
  }, [abierta]);

  const abrir = (k) => { evento('respuesta', { pantalla: 'catalogo', opcion: k }); setProbando(false); setAbierta(k); };
  const probar = () => { evento('respuesta', { pantalla: 'catalogo_demo', opcion: abierta }); setProbando(true); };
  // 🟠 «La quiero» y su mensaje son míos, a validar por An. Pregunta el equipo, que sugiere el plan (planes.js).
  const quiero = () => {
    evento('contacto_abierto', { pantalla: 'catalogo_quiero', opcion: abierta });
    const t = tarea.nombre;
    setAbierta(null);
    abrirChat?.(`Quiero sumar ${t} a mi agencia.`, {
      asunto: 'Postulación a Agencia', servicio: 'Agencia',
      respuestas: { ...datos, tarea: abierta }, preguntas: ['ia_equipo'],
    });
  };
  const solicitar = () => {
    evento('contacto_abierto', { pantalla: 'catalogo', opcion: abierta });
    const t = tarea.nombre;
    setAbierta(null);
    abrirChat?.(`Quiero ver la demo de ${t}.`, {
      asunto: `Demo de ${t}`, servicio: 'Agencia',
      respuestas: { ...datos, tarea: abierta }, preguntas: [],
    });
  };

  return (
    <div className="gh-catalogo">
      <div className="gh-catalogo__agentes">
        {AGENTES.map(a => (
          <section key={a.id} className={`gh-catalogo__agente${a.id === 'tuyas' ? ' is-tuya' : ''}`} aria-labelledby={`gh-ag-${a.id}`}>
            <h3 id={`gh-ag-${a.id}`}>{a.id === 'tuyas' ? '¿No está tu tarea?' : `Agente de ${a.nombre}`}</h3>
            {a.tareas.map(k => (
              <button key={k} type="button" className="gh-catalogo__tarea" onClick={() => abrir(k)}>
                <b>{TAREAS[k].nombre}</b>
                <span>{TAREAS[k].una}</span>
              </button>
            ))}
          </section>
        ))}
      </div>

      <dialog ref={dialogo} className="gh-ficha" aria-labelledby="gh-ficha-titulo" onClose={() => setAbierta(null)}
        onClick={e => { if (e.target === dialogo.current) setAbierta(null); }}>
        {tarea && (
          <div className="gh-ficha__in">
            <button type="button" className="gh-ficha__cerrar" aria-label="Cerrar" onClick={() => setAbierta(null)}>
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" /></svg>
            </button>
            {probando && escena ? (
              <div className="gh-ficha__demo">
                <h2 id="gh-ficha-titulo" className="gh-ficha__titulo">{tarea.nombre}</h2>
                <DemoAgencia key={abierta} escena={escena} />
                <div className="gh-ficha__acciones">
                  <Button variant="solido" onClick={quiero}>La quiero</Button>
                  <button type="button" className="gh-sutil" onClick={() => setProbando(false)}>← Volver al video</button>
                </div>
              </div>
            ) : (
              <div className="gh-ficha__cuerpo">
                <video className="gh-ficha__video" key={abierta} controls playsInline autoPlay muted preload="metadata"
                  poster={`/catalogo/${abierta}.jpg`} aria-label={`Video de ${tarea.nombre}`}>
                  <source src={`/catalogo/${abierta}.mp4`} type="video/mp4" />
                </video>
                <div className="gh-ficha__texto">
                  <h2 id="gh-ficha-titulo" className="gh-ficha__titulo">{tarea.nombre}</h2>
                  <p>{tarea.que}</p>
                  <p className="gh-ficha__nunca">{tarea.nunca}</p>
                  <div className="gh-ficha__acciones">
                    <Button variant="solido" onClick={quiero}>La quiero</Button>
                    {escena
                      ? <Button onClick={probar}>Probar la demo</Button>
                      : <Button onClick={solicitar}>Solicitar demo</Button>}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </dialog>
    </div>
  );
};

export default CatalogoAgencia;
